<template>
<el-card>
    <h1>发起合同签署请求（v2）</h1>
    <el-divider />
    <p class="p-title">
        <strong>接口说明：</strong>
    </p>
    <p>发起企业合同签署请求</p>
    <p class="p-title">
        <strong>请求URL：</strong>
    </p>
    <p>http://api.toursign.cn/v2/company/contract/template/sign</p>
    <p class="p-title">
        <strong>请求方式：</strong>
    </p>
    <p>POST</p>
    <p class="p-title">
        <strong>请求参数说明：</strong>
    </p>
    <p>
        <el-table size="mini" border :data="request">
            <el-table-column prop="name" label="参数名称" />
            <el-table-column prop="loc" label="位置" />
            <el-table-column prop="type" label="类型" />
            <el-table-column prop="required" label="必填" />
            <el-table-column prop="desc" label="说明" />
        </el-table>
    </p>
    <p>业务参数请通过 <el-button type="text" @click="$router.push('/doc/template-search')">模板查询</el-button> 获取</p>
    <p class="p-title">
        <strong>请求示例：</strong>
    </p>
    <pre v-highlight><code class="json">
POST api.toursign.cn/v2/company/contract/template/sign HTTP/1.1

{
    "contractTemplateCode":"QUXCN",
    "businessId": "100992244",
    "contractNo": "NC-2020-0704-01",
    "sealUrl": "http://enterpriseresourceplan.tourtech.cn/uploads/2018/5/23/1/eee1a67261db48febae66451b046eada.png",
    "signatory": {
      "name":"王某某",
      "idNo":"123456",
      "phone":"18989899988",
      "email":"abc@def.com",
      "sex":"男"
    },
    "callBackUrl": "http://xxx.com/contract/success",
    "businessParams": {
      "":""
    }
}
</code></pre>
    <p class="p-title">
        <strong>返回参数说明：</strong>
    </p>
    <p>
        <el-table size="mini" border :data="response">
            <el-table-column prop="name" label="参数名称" />
            <el-table-column prop="type" label="类型" />
            <el-table-column prop="desc" label="说明" />
        </el-table>
    </p>
    <p class="p-title">
        <strong>返回示例：</strong>
    </p>
    <pre v-highlight>
      <code class="json">
{
    "ret": true,
    "contractId": "CONTRACTID"
}
      </code>
      </pre>
</el-card>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            request: [
                {
                    name: "contractTemplateCode",
                    loc: "BODY",
                    type: "String",
                    required: "是",
                    desc: "合同模板Code"
                },
                {
                    name: "businessId",
                    loc: "BODY",
                    type: "String",
                    required: "是",
                    desc: "调用方业务系统内的唯一标识"
                },
                {
                    name: "contractNo",
                    loc: "BODY",
                    type: "String",
                    required: "否",
                    desc: "合同号码，如不传，则由平台自动生成"
                },
                {
                    name: "sealUrl",
                    loc: "BODY",
                    type: "String",
                    required: "是",
                    desc: "公司印章图片地址"
                },
                {
                    name: "signatory",
                    loc: "BODY",
                    type: "Signatory",
                    required: "是",
                    desc: "签约人"
                },
                {
                    name: "- Signatory.name",
                    loc: "BODY",
                    type: "String",
                    required: "是",
                    desc: "签约人姓名"
                },
                {
                    name: "- Signatory.IdNo",
                    loc: "BODY",
                    type: "String",
                    required: "是",
                    desc: "签约人身份证号码"
                },
                {
                    name: "- Signatory.phone",
                    loc: "BODY",
                    type: "String",
                    required: "是",
                    desc: "签约人手机号"
                },
                {
                    name: "- Signatory.email",
                    loc: "BODY",
                    type: "String",
                    required: "否",
                    desc: "签约人电子邮箱"
                },
                {
                    name: "- Signatory.sex",
                    loc: "BODY",
                    type: "String",
                    required: "否",
                    desc: "签约人性别"
                },
                {
                    name: "callBackUrl",
                    loc: "BODY",
                    type: "String",
                    required: "否",
                    desc: "回调地址，当签署成功后平台向调用方发起回调，通知合同签署成功"
                },
                {
                    name: "businessParams",
                    loc: "BODY",
                    type: "Map",
                    required: "是",
                    desc: "业务参数"
                }
            ],
            response: [{
                    name: "ret",
                    type: "Boolean",
                    desc: "响应标识，true 成功 ， false 失败"
                },
                {
                    name: "errCode",
                    type: "String",
                    desc: "错误码，没有返回表示调用成功"
                },
                {
                    name: "contractId",
                    type: "String",
                    desc: "电子合同Id"
                },
                {
                    name: "errMsg",
                    type: "String",
                    desc: "错误信息，没有返回表示调用成功"
                }
            ]
        };
    }
};
</script>
